import React, { Component } from 'react';

import {  SuperscriptionAPI } from '@philips-emr/tws-components-api';
import { Expression } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { array, arrayOf, bool, element, expression, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, propagateProps } from '@philips-emr/tws-utils';

import SuperscriptionItem from './superscription-item';

import './superscription.scss';

const acceptedTypes = [
  ComponentType.DATA_DISPLAY,
];

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: SuperscriptionAPI })
class Superscription extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    data: array.notEnumerable(),
    showLabel: bool,
    showTitle: bool,
    titleExpression: expression,
    uuid: string,
  };

  static defaultProps = {
    data: [],
    titleExpression: Expression.SUPERSCRIPTION,
  };

  renderFromData() {
    const { data, showLabel } = this.props;

    return data.map((item, index) => (
      <SuperscriptionItem key={index} showLabel={showLabel} {...item} />
    ));
  }

  renderItems() {
    const { children, data, showLabel, uuid } = this.props;

    const items =
      Array.isArray(data) && data.length > 0
        ? this.renderFromData()
        : propagateProps(children, { showLabel });

    const Container = ContainerProvider.provide(this);

    return (
      <Container acceptedTypes={acceptedTypes} className="c-superscription__items u-expand" uuid={uuid}>
        {items}
      </Container>
    );
  }

  renderTitle() {
    const { showTitle, titleExpression } = this.props;

    if (!showTitle) {
      return null;
    }

    return (
      <div className="c-superscription__title">{msg(titleExpression)}</div>
    );
  }

  render() {
    const { className } = this.props;

    const names = classNames({
      'c-superscription': true,
      [className]: Boolean(className),
    });

    return (
      <div className={names}>
        {this.renderTitle()}
        {this.renderItems()}
      </div>
    );
  }
}

export default Superscription;
